import * as globalShared from '../../../shared/store/types/global';
import * as files from '../../../shared/store/types/files';
import * as fileImport from '../../../shared/store/types/fileImport';
import * as calendar from '../../../shared/store/types/calendar';
import * as auth from '../../../shared/store/types/auth';
import * as presence from './presence';
import * as presence_employee from '../../../src/store/types/presence_employee';

export const types = Object.assign({}, globalShared, files, fileImport, auth, presence, calendar, presence_employee);
